module.exports = __webpack_public_path__ + "img/Unidad14-5.b5f767af.png";